const id_purch_quotationSales = {
    label: {
        btn_po: "proses PO",
    }
}

export default id_purch_quotationSales;